import {
  BuyerIntentOption,
  BuyerIntentType,
  BuyerStatusType,
  BUYER_TYPES,
  SellerTimelineOption,
  SellerTimeline,
} from "@habity/types";

export const SELLER_TIMELINES: SellerTimelineOption[] = [
  {
    title: "Närsomhelst",
    description: "Vill sälja bostaden till rätt pris",
    value: "sell_at_right_price",
  },
  {
    title: "2-5 år",
    description: "Är öppen att sälja till rätt pris",
    value: "sell_within_a_few_years",
  },
  {
    title: "1 år",
    description: "Vill sälja bostaden inom ett år",
    value: "sell_within_twelve_months",
  },
  // {
  //   title: '3-6 månader',
  //   description: 'Vill sälja bostaden inom ett halvår',
  //   value: 'sell_within_six_months',
  // },
  {
    title: "Så snabbt det går",
    description: "Vill sälja bostaden inom 6 månader",
    value: "sell_now",
  },
];

export const BUYER_INTENTS: BuyerIntentOption[] = [
  {
    title: "Så snabbt det går",
    description: "Vill köpa inom det närmasta halvåret",
    value: "buy_now",
  },
  // {
  //   title: '3-6 månader',
  //   description: 'Vill köpa inom det närmasta halvåret',
  //   value: 'buy_within_six_months',
  // },
  {
    title: "1 år",
    description: "Vill köpa inom de närmaste året",
    value: "buy_within_twelve_months",
  },
  {
    title: "2-5 år",
    description: "Är öppen för att köpa till rätt pris",
    value: "buy_within_a_few_years",
  },
  {
    title: "Ingen alls",
    description: "Inga planer på att köpa bostad",
    value: "not_buy",
  },
];

type SellerEmailTemplate = {
  message: string;
  value: SellerTimeline;
};

export const SELLER_CHAT_TEMPLATES: SellerEmailTemplate[] = [
  {
    message:
      "Hej,\n\nJag har inga aktiva säljplaner just nu, men du får gärna spara min bostad till senare om du känner att den passar dina önskemål.\n\n$LINK",
    value: "sell_at_right_price",
  },
  {
    message:
      "Hej,\n\nJag har inga aktiva säljplaner just nu, men du får gärna spara min bostad till senare om du känner att den passar dina önskemål.\n\n$LINK",
    value: "sell_within_a_few_years",
  },
  {
    message:
      "Hej,\n\nJag går i säljtankar inom det närmaste året och ser att min bostad skulle kunna matcha dina önskemål.\n\n$LINK\n\nSkriv gärna om du är nyfiken eller har några frågor!",
    value: "sell_within_twelve_months",
  },
  {
    message:
      "Hej,\n\nJag kikar på att sälja min bostad inom det närmsta halvåret och ser att den skulle kunna matcha dina önskemål.\n\n$LINK\n\nSkriv gärna om du är nyfiken eller har några frågor!",
    value: "sell_within_six_months",
  },
  {
    message:
      "Hej,\n\nMin bostad är till salu och jag ser att den skulle kunna matcha dina önskemål.\n\n$LINK\n\nSkriv gärna om du är nyfiken eller har några frågor!",
    value: "sell_now",
  },
];

export const DEFAULT_BUYER_INTENT: BuyerIntentType = "buy_now";

export const DEFAULT_BUYER_TYPE: (typeof BUYER_TYPES)[number] =
  "activelyLooking";

export const DEFAULT_BUYER_STATUS: BuyerStatusType = "activelyLooking";
